import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ValidationService } from '../providers/validation.service';
import { CommonService } from '../providers/common.service';
import { PropertyCharacteristics } from './propertydetails';

export interface SavePropertyInputModel {
  Id: number;
  Guid: string;
  LoginUserId: number;
  TenantId?: number;
  TenantTradeName: string;
  TenantName: string;
  IsFranchisee: boolean;
  SPRatingId?: number;
  MoodyRatingId?: number;
  FitchRatingId?: number;
  NoOfUnits: number;
  Guarantor: string;
  GuarantorId: number;
  Address: string;
  StateId?: number;
  CityId?: number;
  BrokerageId?: number;
  Zip: string;
  IsFeatured: boolean;
  YearBuilt?: number;
  Renovated?: number;
  PropertyTypeId?: number;
  SubCategoryId?: number;
  BuildingSize?: number;
  Land?: number;
  PropertyForId?: number;
  PropertyStatusId?: number;
  DataEntryPropertyStatusId?: number;
  Description: string;
  
  NOI: number;
  LeasePricePSF?: number;
  OriginalLeaseTerm?: number;
  LeaseCommencementDate: Date;
  LeaseExpiration: Date;
  RentEscalationPercentage?: number;
  RentEscalationPeriod: number;
  OptionNumber?: number;
  OptionLength?: number;
  IsShowPrice: boolean;
  LeaseStructureId?: number;
  OwnershipTypeId?: number;
  Price?: number;
  PricePSF?: number;
  UnpricedText: string;
  CapRateText: string;
  Notes?: string;
  CapRate?: number;
  DateOnMarket?: Date;
  Latitude: number;
  Longitude: number;
  VideoUrl: string;
  InvestmentHighlights: PropertyHighlightsListOutputModel[];
  ContactOrBrokerInfo: SavePropertyBrokerInputModel[];
  OfferMemoReqApproval?: boolean;
  DueDiligenceReqApproval?: boolean;
  ListedOnMarket?: Date;
  PropertySource: string;
  IsComp?: boolean;
  IsArchive?: boolean;
  IsMarked?: boolean;
  BrokerList: any[];
  PropertySalesInputModel: PropertySalesInputModel[];
  IsSourceChanged?: number;
  BrokersId: number[] | null;
  ConfidentialityAgreement?: boolean;
  DDConfidentialityAgreement?: boolean;
  AutoCalcPSF?: boolean;
  AutoCalcCapRate?: boolean;
  LiveListingId: number | null;
  IsDataEntryProperty?: boolean
  IsRentTermAutoCalc?: boolean;
  PropertyRentTerm?: PropertyRentTermModel[];
  IsShowRentSchedule?: boolean;
  Unpriced?: boolean;
  PropertyTypeList?: number[];
  PropertyTypeSubcategoryList?: number[];
  DisplayName?: string;
  ShowDisplayName?: boolean;
  CharacteristicsId: number[];
  MetatagsId: number[];
  IsSaveOnly?: boolean | false;
  PropertyLeasingHistoryInputModel: PropertyLeasingHistoryInputModel[];
  SaveAsDraft?: boolean | false;
  SaveAsPrincipalDraft?: boolean | false;
  NumberOfLocations?: number;
  NumberOfProperties?: number;
  PortfolioPropertyIds?: number[];
  IsPortfolio?: boolean;
  OwnershipTypeIds?: number[];
  LeaseStructureIds?: number[];
  AutoCalcPrice?: boolean;
  PortfolioRemainingLeaseTerm?: string;
  PortfolioRemainingLeaseTermYear?: number;
  PortfolioRemainingLeaseTermMonth?: number;
  PortfolioOriginalLeaseTerm?: string;

  AutoCalcPortfolioType?: boolean;
  AutoCalcOwnershipType?: boolean;
  AutoCalcRent?: boolean;
  AutoCalcOriginalLeaseTerm?: boolean;
  AutoCalcCommencement?: boolean;
  AutoCalcLeaseExpiration?: boolean;
  AutoCalcRemainingLeaseTerm?: boolean;
  AutoCalcLeaseType?: boolean;
  AutoCalcRentalIncrease?: boolean;
  AutoCalcOptionNumber?: boolean;
  AutoCalcOptionLength?: boolean;
  AutoCalcNumberOfLocations?: boolean;
  AutoCalcNumberOfProperties?: boolean;
  AutoCalcPortfolioSubcategory?: boolean;
  TenantTypeId?: number;
  AutoCalcTenantType?: boolean;
  PortfolioSaleOnly?: boolean;
  PropertySellers: any[];
  AutoCalcLand?: boolean;
  AutoCalcBuildingSize?: boolean;
  IsOfferOnAllProperties?: boolean;
  BovId?: string;
  MetaTags?: string;
  OnlyZCF?: boolean;
  Slug?: string;
  TenantNameText?: string;
  GuarantorName?: string;
  IsNewGuarantor?: boolean;
  IsNewTenant?: boolean;
  ShowNewTenant?: boolean;
  ShowNewGuarantor?: boolean;
  ConfidentialLocation?: boolean;

  //new fields
  InsuranceReimbursement?: number;
  Insurance?: number;
  TaxReimbursement?: number;
  Tax?: number;
  ExpenseReimbursement?: number;
  Expenses?: number;
  Lender?: string;
  Assumable?: boolean;
  PrePay?: boolean;
  MaturityDate?: Date;
  OrginationDate?: Date;
  ExpenseCommencementDate?: Date;
  ExpenseExpirationDate?: Date;
  PropertyTaxCommencementDate?: Date;
  PropertyTaxExpirationDate?: Date;
  InsuranceCommencementDate?: Date;
  InsuranceExpirationDate?: Date;
  ExpenseCategory?: string;
  Amortization?: number;
  InterestRate?: number;
  LoanAmount?: number;
  AcquisitionCapRate?: number;
  AcquisitionPrice?: number;
  UserGuid?: string;
  SalesNotes?: string;
  Source?: string;
}

export interface EditPropertyDeatilsModel extends SavePropertyInputModel {
  PropertyContactPersonsList?: SavePropertyBrokerInputModel[];
  PropertyHighlightsList?: PropertyHighlightsListOutputModel[];
  Images?: ImageOutputModel[];
  Documents?: DocumentOutputModel[];
  PropertySalesDetailList?: PropertySalesInputModel[];
  RevisionIds?: Number[];
}

export interface PropertyContactPersonsListOutputModel {
  Id?: number;
  Name?: string;
  PhoneNo?: string;
  EmailID?: string;
  Photo?: string;
}

export interface ImageOutputModel {
  Id?: number;
  FilePath?: string;
  IsDefault: boolean;
  AlText?: string;
  Caption?: string;
  Description?: string;
  DisplayOrder?: number;
}

export interface DocumentOutputModel {
  Id?: number;
  FilePath?: string;
  Category?: string;
  CategoryId?: number;
  Name: string;
  ObjectId?: number;
}

export interface SavePropertyBrokerInputModel {
  Id: number;
  PropertyId?: number;
  ContactTypeId?: number;
  UserId?: number;
  BrokerRegionalLicenseId?: number;
  ContactType: string;
  Name: string;
  PhoneNumber: string;
  Email: string;
  License: string;
}

export interface PropertyHighlightsListOutputModel {
  Id: number;
  Title: string;
  Description: string;
}

export interface PropertyFile {
  FileContent: File;
  Name: string;
  Url?: string;
  Id?: number;
  IsDefault: boolean;
  AlText?: string;
  Caption?: string;
  Description?: string;
  DisplayOrder?: number;
}

export interface PropertyDocument extends PropertyFile {
  Id: number;
  Category: string;
  CategoryId?: number;
  IsNew: boolean;
  File?: string
}

export interface DocumentCategoryModel {
  Id: number;
  CategoryId: number;
}

export interface ImageDetailModel {
  Id: number;
  AlText?: string;
  Caption?: string;
  Description?: string;
  DisplayOrder?: number;
}

export interface Tenant {
  id: number;
  title: string;
}

export interface BrokerLicenceSelectionModel {
  UserId: number;
  LicenceId: number;
  LicenceName: string;
}

export interface BrokerSelecttionModel {
  Id: number;
  Name: string;
}

export interface PropertySalesInputModel {
  Id: number;
  PropertyId: number;
  SaleDate?: Date;
  SalePrice?: number;
  SaleCapRate?: number;
  SalePSF?: number;
  BrokerageId: number;
  AutoPopulated?: boolean;
  AutoCalcPSF?: boolean;
  AutoCalcCapRate?: boolean;
  NOI: number;
  BuildingSize: number;
  IsAutoGenerated?: boolean;

  DateOnMarket?: Date;
  YearOnMarket?: number;
  MonthOnMarket?: number;
  DayOnMarket?: number;
  AskingPrice?: number;
  AskingCapRate?: number;
  DiscountToAsking?: number;

  BuyerName: string;
  BuyerBrokerageName: string;
  BuyerBrokerName: string;
  SellerName: string;
  SellerBrokerageName: string;
  SellerBrokerName: string;
  RemainingTermYear?: number;
  RemainingTermMonth?: number;
  RemainingTermDay?: number;
  Is1031ExchangeBuyer: boolean | false;
  SaleCharacteristicsId?: number[];
  LTV?: number;
  InterestRate?: number;
  Amortization?: number;
  Term?: number;
  SalesNotes: string;
  AutoCalcDiscount?: boolean;
  GuarantorId?: number;
  SPRatingId?: number;
  MoodyRatingId?: number;
  FitchRatingId?: number;
  LeaseStructureId?: number;
  RentEscalationPercentage?: number;
  RentEscalationPeriod?: number;
  OptionNumber?: number;
  OptionLength?: number;
  SalesNOI?: number;
  BuyerBrokerageId: number;

  Documents?: PropertyDocument[];
  RemovedDocuments?: number[];
  SelectedFiles?: string[]
  Event?: string;
  EventId?: number;
  SaleCharacteristics?: string;
  showChild?: boolean;
  IsAdd?: boolean;
  Index?: number;
  GuarantorName?: string;
  SPRating?: string;
  MoodyRating?: string;
  FitchRating?: string;
  LeaseStructureName?: string;
  ShowDoc?: boolean;
  ShowProp?: boolean;
  CreatedBy?: number;
  ShowRentTerm?: boolean;
  SaleHistoryRentTerm?: PropertyRentTermModel[];
  PropertyCharacteristicsList?: PropertyCharacteristics[];
  capRateText?: string;
}

export interface PropertyRentTermModel {
  Id: number;
  Years: string;
  LeaseStartDate: Date | null;
  LeaseEndDate: Date | null;
  NetOperatingIncome: number;
  Increase: number;
  IsOptional?: boolean;
  IncreaseByPercentage?: boolean;
  IsEditModeOn?: boolean;
}

export interface IGuarantorList {
  Id: number;
  Name: string;
}

export interface PropertyLeasingHistoryInputModel {
  Id: number;
  EventId: number;
  Event: string;
  TenantName: string;
  LeaseExpireDate?: Date;
  PSF?: number;
  LeaseStructureId?: number;
  LeaseStartDate?: Date;
  EscalationPercentage?: number;
  EscalationPeriod?: number;
  OptionLength: number;
  NOI?: number;
  AnnualRent: number;
  //RentTerm?: number;    
  OptionNumber?: number;
  Date: Date;
  PropertyId: number;
  LeaseCommencementDate?: Date;
  YearBuilt?: number;
  Notes: string;
  LeaseStructure: string;
  showChild?: boolean;
  Documents?: PropertyDocument[];
  RemovedDocuments?: number[];
  SelectedFiles?: string[];
  ShowDoc?: boolean;
  Index?: number;
  CreatedBy?: number;
  AutoCalcRentTerm?: boolean
}

export interface PropertySaleHistoryModel {
  Id: number;
  PropertyId: number;
  SaleDate?: Date;
  SalePrice?: number;
  SaleCapRate?: number;
  SalePSF?: number;
  BrokerageId: number;

  DateOnMarket?: Date;
  YearOnMarket?: number;
  MonthOnMarket?: number;
  DayOnMarket?: number;
  AskingPrice?: number;
  AskingCapRate?: number;
  DiscountToAsking?: number;

  BuyerName: string;
  BuyerBrokerageName: string;
  BuyerBrokerName: string;
  SellerName: string;
  SellerBrokerageName: string;
  SellerBrokerName: string;
  RemainingTermYear?: number;
  RemainingTermMonth?: number;
  RemainingTermDay?: number;
  SalesNotes?: string;
  BuyerBrokerageId?: number;
  Event: string;
  EventId?: number;
  SaleCharacteristicsId?: number[];
  SaleCharacteristics?: string;
  showChild?: boolean;
  Documents?: PropertyDocument[];
  RemovedDocuments?: number[];
  SelectedFiles: string[]
}

export interface IDuplicates {
  PropertyId: number;
  TenantId: number;
  StateId: number;
  CityId: number;
  Address: string;
  ZIP: string;
  Type: number;
}

export interface IPortfolioPropertySuggestOutputModel {
  PropertyName: string;
  CreditRating: string;
  BrokerCount: number;
  RemainingTerm: string;
  CapRate: string;
  AssetType: string;
  Price: number;
  BuildingSize: string;
  Id: number;
  Guid: string;
  Latitude: string;
  Longitude: string;
  Lat: number;
  Lng: number;
  TotalCount: number;
  PropertyStatus: string;
  City: string;
  State: string;
  RentNOI: number;
  LeaseStructure: string;
  IsFav: number;
  IsDisliked: number;
  Is1031Exchange: number;
  Exchange1031Id: any;
  Exchange1031GroupId: any;
  OfferPlaced: number;
  OfferPlacedStatusId: number;
  OfferDetailGuid: string;
  DefaultPic: string;
  FilePath: string;
  Rating: string;
  RatingType: string;
  IsShowPrice: boolean;
  PropertyFor: string;
  PropertyForId: number | null;
  AssociatedBrokers: string;
  CompId: number;
  ArchiveId: number;
  IsViewed: number;
  IsChecked: boolean;
  OMFilePath: string;
  DisabledSelection: boolean;
  PropertyTypeIds: number[];
  PropertyTypeSubcategoryIds: number[];
  CharacteristicsId: number;
}

export function spaceOnlyValidator(c: AbstractControl): ValidationErrors {
  if (c.value === '' || c.value === null) { return null; }
  const isYes = c.value?.trim().length === 0 ? true : false;
  return isYes ? { 'spaceOnly': { value: 'The value cannot be only white spaces' } } : null;
}

export function numberOfUnitsValidator(isRequired: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const isYes = isRequired ? (control.value > 0 ? false : true) : false;
    return isYes ? { 'nouRequiredwhenFranchisee': { value: 'No. of units is required when the property is franchisee' } } : null;
  };
}

export function minimumYearValidator(fc: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const cDate = new Date(control.value);
    if (control.value == 'Invalid Date') {
      return { 'minYear': { value: 'Minimum year does not meet' } }
    }
    const isYes = cDate.getFullYear() < fc();
    return isYes ? { 'minYear': { value: 'Minimum year does not meet' } } : null;
  };
}

export function maxYearValidator(fc: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const cDate = new Date(control.value);
    const isYes = cDate.getFullYear() > fc();
    return isYes ? { 'maxYear': { value: 'Maximum year does not meet' } } : null;
  };
}

export function maxValidator(fc: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const isYes = control.value > fc();
    return isYes ? { 'maxValue': { value: 'Maximum value does not meet' } } : null;
  };
}

export function minValidator(fc: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const isYes = control.value < fc() && control.value;
    return isYes ? { 'minValue': { value: 'Minimum value does not meet' } } : null;
  };
}

export function defaultValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return null;
  };
}

export function minimumDateValidator(getDateFunction: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const cDate = new Date(control.value);
    if (control.value == 'Invalid Date') {
      return { 'minDate': { value: 'Minimum date value does not meet' } }
    }
    const isYes = cDate < (getDateFunction() as Date);
    return isYes ? { 'minDate': { value: 'Minimum date value does not meet' } } : null;
  };
}

export function maxDateValidator(getDateFunction: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const cDate = new Date(control.value);
    const isYes = cDate > (getDateFunction() as Date);
    return isYes ? { 'maxDate': { value: 'Maximum date value does not meet' } } : null;
  };
}

export function vimeoUrlValidator(validationService: ValidationService): ValidatorFn {
  return (control: AbstractControl) => {
    const isYes = control.value ? !validationService.isValidVimeoUrl(control.value) : false;
    return isYes ? { 'vimeoUrl': { value: 'Invalid vimeo url' } } : null;
  };
}
